<ng-container *ngIf="viewModel.isEdiblesCard$ | async; else regularCard">
  <app-label-inflator
    #labelCalculator
    hidden
    class="label-calculator"
    [calculateVirtualLabel]="true"
    [columnLabel]="false"
    [labelComponentInterface]="data"
    [reset]="false">
  </app-label-inflator>
  <div class="main-content">
    <div
      class="product-card-variant-type"
      appPrintCardScaleDownText
      [maxHeightInPx]="32"
      [maxWidthInPx]="248"
      [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
      [style.color]="viewModel.headerTextColor$ | async">
      {{ viewModel.topOfCardVariantType$ | async }}
    </div>
    <div
      *ngIf="data | sectionRowViewModelBasicMethod: 'getBrand' as brand"
      appPrintCardScaleDownText
      [maxHeightInPx]="32"
      [maxWidthInPx]="248"
      class="product-card-brand"
      [style.color]="viewModel.bodyTextColor$ | async">
      {{ brand }}
    </div>
    <div class="product-card-product-name">
      {{ data | sectionRowViewModelBasicMethod: 'getRowTitle' | trimSafely }}
    </div>
    <div class="product-card-flavours">
      <div class="product-card-number-of-flavours" [style.color]="viewModel.bodyTextColor$ | async">
        <div class="product-card-flavor-text">{{ viewModel.numberOfFlavours$ | async }} Flavours</div>
        <hr class="separator" />
      </div>
      <div
        *ngFor="let variant of viewModel.visibleVariantFlavours$ | async"
        class="product-card-individual-product-info">
        <div
          class="product-card-variant-name"
          appPrintCardScaleDownText
          [maxHeightInPx]="14"
          [maxWidthInPx]="248"
          [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
          [style.color]="viewModel.bodyTextColor$ | async">
          {{ data | sectionRowViewModelBasicMethod: 'getRowTitleFor' : variant | trimSafely }}
        </div>
        <div
          *ngIf="
            !(data | sectionRowViewModelBasicMethod: 'isVariantAnAccessory' : variant) &&
            !(data | sectionRowViewModelBasicMethod: 'isVariantNonCannabinoidOtherVariant' : variant)
          "
          class="product-card-cannabinoids"
          [style.color]="viewModel.bodyTextColor$ | async">
          @let thc = viewModel.thcFromPool$ | async;
          @let cbd = viewModel.cbdFromPool$ | async;
          <div *ngIf="thc" class="cannabinoid">
            <div class="cannabinoid-title">{{ thc?.title }}</div>
            <div class="cannabinoid-value">{{ thc?.value | trimSafely }}</div>
          </div>
          <div *ngIf="thc && cbd" class="cannabinoid-separator">|</div>
          <div *ngIf="cbd" class="cannabinoid">
            <div class="cannabinoid-title">{{ cbd?.title }}</div>
            <div class="cannabinoid-value">{{ cbd?.value | trimSafely }}</div>
          </div>
        </div>
        <div class="product-card-strain-type-and-size" [style.color]="viewModel.bodyTextColor$ | async">
          <div class="badge-container">
            <img
              *ngFor="let variantBadge of data | getBadgesFor: variant"
              appImage
              class="print-card-badge"
              [asset]="variantBadge?.image"
              alt="badge"
              src="" />
          </div>
          <div
            *ngIf="
              !(viewModel.isAccessory$ | async) &&
              !(viewModel.isNonCannabinoidOtherVariant$ | async) &&
              (data | sectionRowViewModelBasicMethod: 'getReadableStrainTypeFor' : variant | trimSafely) as strainType
            "
            class="product-card-strain">
            {{ strainType }}
          </div>
          <div
            *ngIf="
              !(viewModel.isAccessory$ | async) &&
              !(viewModel.isNonCannabinoidOtherVariant$ | async) &&
              (data | sectionRowViewModelBasicMethod: 'getReadableStrainTypeFor' : variant | trimSafely) &&
              (data | sectionRowViewModelBasicMethod: 'getSize' : variant | trimSafely)
            "
            class="strain-and-size-separator">
            |
          </div>
          <div
            *ngIf="
              !(viewModel.isAccessory$ | async) &&
              !(viewModel.isNonCannabinoidOtherVariant$ | async) &&
              (data | sectionRowViewModelBasicMethod: 'getSize' : variant | trimSafely | replace: ' ' : '') as size
            "
            class="product-card-size">
            {{ size }}
          </div>
          <div class="label-container">
            <app-label-inflator
              class="print-card-label"
              [columnLabel]="false"
              [labelComponentInterface]="data | sectionRowViewModelBasicMethod: 'labelInterfaceFor' : variant"
              [reset]="false">
            </app-label-inflator>
          </div>
        </div>
      </div>
      <div *ngIf="viewModel.nMoreFlavours$ | async as nFlavours" class="plus-n-more-flavours">
        +{{ nFlavours }} More
      </div>
    </div>
    <div class="product-card-price">
      <app-fika-size-and-price
        [includeSize]="viewModel.includeSizeInPrice$ | async"
        [singlePrice]="true"
        [rowVm]="viewModel.cardData$ | async"
        [colVms]="viewModel.spoofedGridColViewModels$ | async"
        [locationConfig]="viewModel.locationConfig$ | async"
        [saleText]="viewModel.virtualLabelText$ | async">
      </app-fika-size-and-price>
    </div>
  </div>
</ng-container>

<ng-template #regularCard>
  <app-fika-index-card-content [cardData]="data"></app-fika-index-card-content>
</ng-template>
